<template>
  <div>
    <div v-if="auditRecord">
      <span>{{fullName}}</span>
      <br>
      <span>{{tools.formatDate(new Date(auditRecord.actionTime))}}</span>
      <br>
      <span>{{auditRecord.summary}}</span>
    </div>
    <div v-else>
      <p>None</p>
    </div>
  </div>
</template>
<script>

import Tools from "@/app-model/tools";

export default {
  props: {
    macAddress: String,
  },
  data () {
    return {
      // For now we only support showing the most recent audit log
      auditRecord: null,
    }
  },
  computed: {
    tools: function () {
      return new Tools;
    },
    // Compute the full name when some of the components may be null
    fullName() {
      if (this.auditRecord == null) {
        return '';
      }
      const actor = this.auditRecord.actor;
      if (actor == null) {
        return '';
      }
      return [actor.firstName, actor.lastName].filter((item) => item != null).join(' ');
    }
  },
  mounted () {
    this.fetchAuditRecord();
  },
  methods: {
    async fetchAuditRecord() {
      return this.$store.dispatch('apiResult', {
        method: 'GET',
        path: `api/v1/audit/records?limit=1&deviceMacAddress=${this.macAddress}`,
        path_template: '/api/account', // This is used to check permissions. Everyone should have access to check their own account
        section: 'fixture'
      }).then(response => {
        switch (response.status) {
          case 200 :
            if (response.data.data.length === 1) {
              this.auditRecord = response.data.data[0];
            }
            break
          case 401 :
            console.warn('Fetch audit record: 401')
            break
        }
        return response;
      });
    },
  }
}
</script>
<style>
</style>
